import React, {
  PropsWithChildren,
  ClassAttributes,
  HTMLAttributes,
} from 'react';
import styles from './H1.module.css';

export const H1 = (
  props: JSX.IntrinsicAttributes &
    ClassAttributes<HTMLHeadingElement> &
    HTMLAttributes<HTMLHeadingElement> &
    PropsWithChildren,
) => <h1 className={styles.h1} {...props} />;
